/*
 * @Author: Src
 * @Date: 2025-06-30 16:53:28
 * @LastEditTime: 2025-07-24 11:22:55
 * @LastEditors: Src
 * @FilePath: /work-station/src/config.ts
 * @Description: 头部注释配置模板
 */
import dev from './config/config.test';
import prod from './config/config.production';
import local from './config/config.local';

let config: {
  API_URL?: string;
  RBAC_URL?: string;
  AUDIT_URL?: string;
  CAR_URL?: string;
} = {};
if (process.env.NODE_ENV === 'development') {
  config = dev;
} else if (process.env.NODE_ENV === 'production') {
  config = prod;
} else {
  config = local;
}

export default {
  ...config,
  isProd: process.env.NODE_ENV === 'production',
};
